import React, {Component} from 'react'
import './Award.css';

/**
 * Award
 */
export default class Award extends Component {

    render() {

        const {image, awardName, awardNameObject, info, infoObject} = this.props;

        let text1 = '';
        let text2 = '';
        let text3 = '';
        let text4 = '';

        if (infoObject) {
            text1 = infoObject.text1;
            text2 = infoObject.text2;
            text3 = infoObject.text3;
            text4 = infoObject.text4;
        }

        return (
            <div className="award">
            <span>
                <img alt="Award"
                     src={image}/>
            </span>

                {awardName &&
                <span>{awardName}</span>}

                {awardNameObject &&
                <span>{this.props.awardNameObject.text1}<br/>{this.props.awardNameObject.text2}</span>}


                {info &&
                <span>{info}</span>}

                {infoObject &&
                <span>{text1}<br/>{text2}<br/>{text3}<br/>{text4}</span>}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Award/Award.jsx